import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let commitmentSwiperWr = document.querySelectorAll('.commitment-swiper-wr');
commitmentSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
     let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 22,
      slidesPerView: 1,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        552: {
          spaceBetween: 24,
          slidesPerView: 2,
        },
        640: {
          spaceBetween: 24,
          slidesPerView: 3,
        },
        767: {
          spaceBetween: 24,
          slidesPerView: 3,
        },
        851: {
          spaceBetween: 24,
          slidesPerView: 4,
        },
        1023: {
          spaceBetween: 24,
          slidesPerView: 5,
        },
        1200: {
          spaceBetween: 32,
          slidesPerView: 5,
        },
        1300: {
          spaceBetween: 50,
          slidesPerView: 5,
        },
      },
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
    });
    swiperObserver(swiper);
  }
});